import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SmallDisplayBox.css';

export class SmallDisplayBox extends Component {
  renderHeadingStyle(type, length) {
    if (type === 'Baseline') {
      return 'small-display__heading--baseline';
    } else if (type === 'Target') {
      return 'small-display__heading--target';
    } else if (type === 'Actual') {
      return 'small-display__heading--actual';
    } else if (length === 1) {
      return 'small-display__heading--savings';
    }
    return null;
  }

  renderDisplayText(content, length) {
    const { type = '', total = '', unit = '' } = content;
    let formattedTotal = total;
    if (unit === 'CAD') {
      if (total < 0) {
        formattedTotal = `-$${-total}`;
      } else {
        formattedTotal = `$${total}`;
      }
    }
    return (
      <div className="small-display__text">
        <div className="small-display__subheading">{`${type} ${(length === 1) ? '' : 'Usage'}`}</div>
        <div className={`small-display__heading ${this.renderHeadingStyle(type, length)}`}>
          {`${formattedTotal} ${unit}`}
        </div>
      </div>
    );
  }

  renderLayout() {
    const { contents = [] } = this.props;

    if (contents.length === 0) {
      return null;
    }

    return (
      <div className="small-display__layout">
        {contents.map((content, index) => (
          <React.Fragment key={`${index}`}>
            {!(index === 0) ? <div className="small-display__bar" /> : null}
            <div className="small-display__text-wrapper">{this.renderDisplayText(content, contents.length)}</div>
          </React.Fragment>
        ))}
      </div>
    );
  }

  render() {
    return <div className="small-display">{this.renderLayout()}</div>;
  }
}

SmallDisplayBox.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    total: PropTypes.string,
    unit: PropTypes.string,
    date: PropTypes.string,
  })),
};

SmallDisplayBox.defaultProps = { contents: [] };
